export const Filters = {
	All: 'all',
	Read: 'R',
	Unread: 'U',
};

export const FAILED_REPORT_GENERATION = 'FAILED_REPORT_GENERATION';
export const SUCCESSFUL_REPORT_GENERATION = 'SUCCESSFUL_REPORT_GENERATION';

export const buttonGroupAllowed = [
	'FAILED_WITHOUT_INCIDENT_REPORT_GENERATION',
	'ONE_TIME_REPORT_SUBMISSION',
	'RECURRING_REPORT_SUBMISSION',
	'CANCEL_RECURRING_REPORT',
	'UPDATE_RECURRING_REPORT',
	FAILED_REPORT_GENERATION,
	SUCCESSFUL_REPORT_GENERATION,
];
